module.exports = "https://jsak.mmtcdn.com/tripmoney/static/media/Air India SBI Signature Card.56a92859.png";